import React from 'react';

import ProjectController from '../../controller/ProjectController';
import Const from '../../util/Constants';

import FieldText from '../common/FieldText';
import FieldDate from '../common/FieldDate';
import FieldDateTime from '../common/FieldDateTime';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';
import FieldToggle from '../common/FieldToggle';
import FieldAddress from '../common/FieldAddress';
import FieldNumber from '../common/FieldNumber';

class ProjectAddEditCustom extends React.Component {

  getCustomFields = (project, fields, onValueChange, inValid) => {
    const fieldOption = this.props.fieldOption;
    const customField = ProjectController.getCustomFields(fields);
    let list = [];
    const keys = Object.keys(customField);
    for(let i = 0; i < keys.length; i++) {
      const type = customField[keys[i]].field_type;
      const key = keys[i];
      const field = customField[key];
      const value = project[key];
      const innerData = { key: key, id: key, field: field, value: value,
        onValueChange: onValueChange, inValid: inValid, fieldOption };
      if(type === Const.Text || type === Const.TextArea) list.push(<FieldText {...innerData}/>);
      else if(type.includes(Const.MultiSelect)) list.push(<FieldMultiSelect {...innerData}/>);
      else if(type.includes(Const.Select)) list.push(<FieldSelect { ...innerData } />);
      else if(type === Const.Date) list.push(<FieldDate { ...innerData } />);
      else if(type === Const.DateTime) list.push(<FieldDateTime { ...innerData } />);
      else if(type === Const.Toggle) list.push(<FieldToggle { ...innerData } />);
      else if(type === Const.Address) list.push(<FieldAddress { ...innerData } />);
      else if(type === Const.Number) list.push(<FieldNumber { ...innerData } />);
    }
    return list;
  }
  
  render() {
    const project = this.props.project;
    const fields = this.props.model.fields;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;

    const list = this.getCustomFields(project, fields, onValueChange, inValid);
    if(list.length === 0) return null;
    return <><div className="formhead col-md-12"><h2>Additional Information</h2></div>{list}</>;
  }
}

export default ProjectAddEditCustom;